module.exports = __webpack_public_path__ + "img/generic-background-mobile.4e6d10e3.png";